import { queryOptions, useQuery } from '@tanstack/react-query';

import { helpCenterApi } from '../api/help-center-api';

import { helpCenterKeys } from './help-center-keys';

/** The whole bounded list, in position order. */
export function helpCategoriesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: helpCenterKeys.categories(storeId),
    queryFn: () => helpCenterApi.listCategories(storeId),
  });
}

export function useHelpCategories(storeId: string) {
  return useQuery(helpCategoriesQueryOptions(storeId));
}
